import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['refresh'];

  connect() {
    // Breaking out of Turbo Frame on redirect
    // The idea is for initial rendering of forms (even in a bootrap modal or offcanvas)
    // you can use turbo frames and have your link target the frame. However on success
    // you can break the frame and do a full page reload just by adding the turbo_frame=_top param
    // to any url you want to redirect to. It is intercepted and the param dropped
    // from the URL before redirecting the browser.
    //
    // In the Rails controller:
    //   redirect_to posts_path('turbo_frame': '_top')
    //
    document.addEventListener("turbo:before-fetch-response", (event) => {
      const {url, redirected} = event.detail.fetchResponse.response;
      if (redirected && url.match("turbo_frame=_top")) {
        event.preventDefault()

        const location = new URL(url);
        location.searchParams.delete('turbo_frame');
        window.location = location.toString();
      }
    });
  }

  // This is used inside a Turbo Frame tag.
  // <turbo-frame id="car_manual_input">
  //   <a href="/path" data-interactions-target="refresh"></a>
  //   .. Rest of the code
  // </turbo-frame>
  refresh(event) {
    const elm = event.target;
    const turboFrame = elm.closest('turbo-frame');
    if (!turboFrame || !this.refreshTarget) return;

    let url = this.refreshTarget.getAttribute('href') || '';
    const urlParams = new URLSearchParams(this.queryString(url));

    if (elm.name) {
      urlParams.set(elm.name, elm.value);
    }
    turboFrame.src = `${this.baseUrl(url)}?${urlParams}`;
  }

  show(event) {
    const elm = event.target;
    if (!elm.dataset.showSelector) {
      console.warn('There is no data attribute called "show-selector"');
      return;
    }

    this.element.querySelectorAll(elm.dataset.showSelector).forEach((target) => {
      target.classList.remove('hidden');
    });
  }

  // ======= PRIVATE =======

  baseUrl(urlString) {
    return urlString.split('?')[0] || '';
  }

  queryString(urlString) {
    return urlString.split('?')[1] || '?';
  }
}
